<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <transition
        name="el-loading-fade"
        @after-leave="handleAfterLeave"
    >
        <div
            v-show="visible"
            class="el-loading"
            :class="{ 'is-fullscreen': fullscreen }"
        >
            <div
                class="el-loading__backdrop"
                :style="`opacity: ${opacity || 1}`"
                :class="{ [`el-loading__backdrop--color-${background}`]: !!background }"
            />
            <div class="el-loading__content">
                <el-spinner
                    :color="color || 'brand-secondary'"
                    :size="size || 16"
                />
                <div
                    v-if="text"
                    class="el-loading__text"
                >
                    <span
                        :class="{ [`el-loading__text--color-${textColor}`]: !!textColor }"
                    >
                        {{ text }}
                    </span>
                </div>
            </div>
        </div>
    </transition>
</template>

<script setup>
import ElSpinner from '@core/components/spinner/spinner.vue';

const emit = defineEmits(['after-leave']);

defineProps({
    visible: { type: Boolean, default: true },
    fullscreen: { type: Boolean, default: false },
    background: { type: String, default: '' },
    opacity: { type: Number, default: 1 },
    color: { type: String, default: 'brand-primary' },
    size: { type: [Number, String], default: 16 },
    text: { type: String, default: '' },
    textColor: { type: String, default: 'fixed-primary' },
});


function handleAfterLeave() {
    emit('after-leave');
}
</script>

<style scoped lang="postcss">
.el-loading {
    line-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    z-index: 9999;
    border-radius: inherit;
    box-sizing: border-box;
    * {
        box-sizing: border-box;
    }
    &__content {
        text-align: center;
    }
    &__backdrop {
        background-color: transparent;
        position: absolute;
        top: 0px;
        right: 0px;
        bottom: 0px;
        left: 0px;
        border-radius: inherit;
        &--color {
            &-inversed-secondary {
                background-color: var(--av-inversed-secondary);
            }
            &-solid-brand-ightest {
                opacity: 0.95;
                background-color: var(--av-solid-brand-lightest);
            }
            &-brand-lightest {
                background-color: var(--av-brand-lightest);
            }
            &-brand-accent {
                background-color: var(--av-brand-accent);
            }
            &-brand-primary {
                background-color: var(--av-brand-primary);
            }
            &-brand-light {
                background-color: var(--av-brand-light);
            }
            &-brand-lighter {
                background-color: var(--av-brand-lighter);
            }
            &-fixed-secondary {
                background-color: var(--av-fixed-secondary);
            }
            &-inversed-primary {
                background-color: var(--av-inversed-primary);
            }
            &-fixed-primary {
                background-color: var(--av-fixed-primary);
            }
            &-fixed-primary, &-fixed-white, &-fixed-secondary {
                opacity: 0.8;
            }
        }
    }
    &__text {
        @mixin body;
        margin-top: 16px;
        &--color {
            &-white {
                color: var(--av-inversed-primary);
            }
            &-fixed-primary {
                color: var(--av-fixed-primary);
            }
            &-fixed-light {
                color: var(--av-fixed-light);
            }
        }
    }
}

.el-loading-fade-enter-active,
.el-loading-fade-leave-active {
  transition: opacity 0.3s ease;
}

.el-loading-fade-enter-from,
.el-loading-fade-leave-to {
  opacity: 0;
}

.el-loading-fade-enter-to,
.el-loading-fade-leave-from {
  opacity: 1;
}
</style>
